import { render, staticRenderFns } from "./attparam.vue?vue&type=template&id=f1dcbbc6&scoped=true"
import script from "./attparam.vue?vue&type=script&lang=js"
export * from "./attparam.vue?vue&type=script&lang=js"
import style0 from "./attparam.vue?vue&type=style&index=0&id=f1dcbbc6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1dcbbc6",
  null
  
)

export default component.exports